import CIMSBadge from 'components/CIMSBadge'
import { CIMSBadgeProps } from 'components/CIMSBadge/types'
import { Internal } from '../../../../../PayItemsModuleContext/types'

const InternalMenuItem: React.FC<Internal & CIMSBadgeProps> = ({
  internal: {
    module: { name },
  },
  count = 0,
}) => {
  if (count > 0) return <CIMSBadge count={count}>{name}</CIMSBadge>
  return <>{name}</>
}

export default InternalMenuItem
